import { render } from "./PaymentSystemAccounts.vue?vue&type=template&id=70391e87&scoped=true&ts=true"
import script from "./PaymentSystemAccounts.vue?vue&type=script&lang=ts"
export * from "./PaymentSystemAccounts.vue?vue&type=script&lang=ts"

import "./PaymentSystemAccounts.vue?vue&type=style&index=0&id=70391e87&lang=scss&scoped=true"

import exportComponent from "/root/source/core/frontend/affiliate/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-70391e87"]])

export default __exports__
import QIcon from 'quasar/src/components/icon/QIcon.js';
import qInstall from "../../../../node_modules/vue-cli-plugin-quasar/lib/runtime.auto-import.js";
qInstall(script, 'components', {QIcon});
